import { render, staticRenderFns } from "./EmulatorCustomizationTextBox.vue?vue&type=template&id=bc813540"
import script from "./EmulatorCustomizationTextBox.vue?vue&type=script&lang=js"
export * from "./EmulatorCustomizationTextBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports